import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

function FormReassignmentPermissionSelector({
  value,
  options,
  onChange,
  disabled,
}) {
  const onSelect = useCallback((selected) => {
    onChange(selected ?? null);
  }, [onChange]);

  return (
    <Select
      options={options}
      value={value ?? undefined}
      disabled={disabled}
      onChange={onSelect}
      allowClear
      dropdownMatchSelectWidth={false}
      getPopupContainer={() => document.body}
      style={{ width: '100%', maxWidth: 180 }}
    />
  );
}

FormReassignmentPermissionSelector.propTypes = {
  value: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

FormReassignmentPermissionSelector.defaultProps = {
  value: null,
  disabled: false,
};

export default FormReassignmentPermissionSelector;
